import $ from "jquery";
import {
  pergola,
  pergolaConst,
  theModel,
  toggleLoad,
} from "../../../core/3d-configurator";
import { state } from "../../../core/settings";
import {
  stringEndCuts,
  stringPostType,
  stringRoofType,
  stringTypeModel,
} from "../../Interface/interface";
import {
  stringNameFrameColor,
  stringNameRoofColor,
  stringNameRoofLetticeColor,
  stringNameRoofSolidColor,
} from "../../Interface/interfaceItems/interfaceGroup/interfaceGroupInputs/interfaceGroupInputs";
import { loadFormData } from "./summary-page-portal/summaryPagePortal";
import "./summaryPage.scss";
export let countLeds = {
  count: 0,
};

export function countVisibleObjectsByName(
  scene,
  name,
  exactMatch = false,
  checkChildrenVisible = false
) {
  let count = 0;

  scene.traverse((object) => {
    const isMatch = exactMatch
      ? object.name === name
      : object.name.includes(name);

    const isTargetType = object.isMesh || object.type === "Group";

    if (!isMatch || !isTargetType || !object.visible) return;

    if (checkChildrenVisible && object.children.length > 0) {
      const allChildrenVisible = object.children.every(
        (child) => child.visible
      );
      if (!allChildrenVisible) return;
    }

    count++;
  });

  return count;
}

export function countActiveSystemsInPergola(typeSystem) {
  const count = pergola.span.objects
    .filter((span) => span.isSystemSet)
    .filter((span) =>
      span.systems.some((system) => system.active && system.type === typeSystem)
    );

  return count.length;
}
const wallAddOptionString = {
  0: "Freestanding",
  1: "Wall-mounted",
  2: "Fascia-mounted",
  3: "Roof-mounted",
  4: "Cantilever",
};

const thicknessString = {
  0: `1"x4"`,
  1: `2"x2"`,
  3: `3"x3"`,
};

export function summaryPageComponent(container) {
  const modelType = stringTypeModel[state.type3Dmodel];
  const wall =
    [
      state.backWall && "Back Wall",
      state.leftWall && "Left Wall",
      state.rightWall && "Right Wall",
    ]
      .filter(Boolean)
      .join(", ") || `${wallAddOptionString[state.wallOption]}`;

  const roofType = stringRoofType[state.roofType];
  const stringPostTypeNew = {
    0: `4" x 4"`,
    1: `6" x 6"`,
    2: `8" x 8"`,
  };
  const postType = stringPostTypeNew[state.postSize];
  const postSize = `${state.postSize}' x ${state.postSize}'`;
  const endCuts = ``;

  const frameColor = state.colorBody;
  const roofColor = state.colorRoof;

  const ledLight = state.ledLights ? `${countLeds.count}` : "No";
  const brightness =
    state.colorLed === "#FAFFC4" ? "3500 lumens" : "2500 lumens";
  const frequency = `Every ${state.spacing} louvers`;
  const fans = state.fans ? `Yes` : "No";
  const heaters = state.heaters ? `Yes` : "No";

  // const isTexture =
  //   typeof state.colorBody === "string" &&
  //   /\.(jpe?g|png|webp)$/i.test(state.colorBody);

  const styleFrame = `background-color: ${state.colorBody}; background-size: cover; background-position: center;`;
  const styleRoofLettice = `background-color: ${
    state.colorRoof.includes(".") ? "#A56025" : state.colorRoof
  };   background-size: cover; background-position: center;`;

  const summaryContent = $(`
    <div id="summary-content">
  <div class="sum__page" id="sum-page">
    <h2 class="sum__page__title">Summary</h2>
    <div class="sum__page__close" id="sum-close"></div>

    <div id="js-summary-image-preview-1">
      <img class="sum__page__img" />
    </div>

    <ul class="sum__page__main-list">
      <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Manufacturer</p>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Type</h3>
          <div class="sum__page__main-list__info__param">${modelType}</div>
        </div>
      </li>

     <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Wall</p>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Type</h3>
          <div class="sum__page__main-list__info__param">${wall}</div>
        </div>
      </li>

    <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Roof Type</p>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Type</h3>
          <div class="sum__page__main-list__info__param">${roofType}</div>
        </div>
        
        
        ${
          // SOLID SETTINGS FROM POP-UP
          state.roofType === 0
            ? `
           <div class="sum__page__main-list__info"> 
             <h3 class="sum__page__main-list__info__title">Beam Size</h3>
             <div class="sum__page__main-list__info__param">${
               !state.beamSize ? `2"x8"` : `2"x10"`
             }</div>
           </div>


           <div class="sum__page__main-list__info"> 
             <h3 class="sum__page__main-list__info__title">Make Roof Overhang</h3>
             <div class="sum__page__main-list__info__param">${
               state.overhang ? "Yes" : "No"
             }</div>
           </div>

           <div class="sum__page__main-list__info"> 
             <h3 class="sum__page__main-list__info__title">Side Beam</h3>
             <div class="sum__page__main-list__info__param">${
               state.sideBeam ? "Yes" : "No"
             }</div>
           </div>


           <div class="sum__page__main-list__info"> 
             <h3 class="sum__page__main-list__info__title">Double Header</h3>
             <div class="sum__page__main-list__info__param">${
               state.doubleBeam ? "Yes" : "No"
             }</div>
           </div>
          `
            : ""
        } 

        ${
          // LATTICE SETTINGS FROM POP-UP
          state.roofType === 1
            ? `
           <div class="sum__page__main-list__info"> 
             <h3 class="sum__page__main-list__info__title">Thickness</h3>
             <div class="sum__page__main-list__info__param">${
               thicknessString[state.thickness]
             }</div>
           </div>

           <div class="sum__page__main-list__info"> 
             <h3 class="sum__page__main-list__info__title">Beam Size</h3>
             <div class="sum__page__main-list__info__param">${
               !state.beamSize ? `2"x8"` : `2"x10"`
             }</div>
           </div>
           
           <div class="sum__page__main-list__info"> 
             <h3 class="sum__page__main-list__info__title">Direction</h3>
             <div class="sum__page__main-list__info__param">${
               state.directionRoof ? `Perpendicular` : `Horizont`
             }</div>
           </div>

           <div class="sum__page__main-list__info"> 
             <h3 class="sum__page__main-list__info__title">Make Roof Overhang</h3>
             <div class="sum__page__main-list__info__param">${
               state.overhang ? "Yes" : "No"
             }</div>
           </div>

           <div class="sum__page__main-list__info"> 
             <h3 class="sum__page__main-list__info__title">Polycarbonate</h3>
             <div class="sum__page__main-list__info__param">${
               state.rain ? "Yes" : "No"
             }</div>
           </div>
          `
            : ""
        } 
    </li>

    <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Dimensions</p>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Width</h3>
          <div class="sum__page__main-list__info__param">${state.width}'</div>
        </div>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Projection</h3>
          <div class="sum__page__main-list__info__param">${state.length}'</div>
        </div>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Height</h3>
          <div class="sum__page__main-list__info__param">${state.height}'</div>
        </div>
      </li>

      <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Post size</p>

       ${
         state.postType
           ? `<div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Size</h3>
          <div class="sum__page__main-list__info__param">${postSize}</div>
        </div>`
           : ""
       } 

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Type post</h3>
          <div class="sum__page__main-list__info__param">${postType}</div>
        </div>
      </li>

      <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Frame color</p>

        <div class="sum__page__main-list__info"> 
          <div class="sum__page__main-list__info__color" style="${styleFrame}"></div>
          <div class="sum__page__main-list__info__param">${stringNameFrameColor}</div>
        </div>
      </li>

      <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Roof color</p>

            <div class="sum__page__main-list__info">
             <div
               class="sum__page__main-list__info__color"
               style="${styleRoofLettice}"
             ></div>
             <div class="sum__page__main-list__info__param">
              ${stringNameRoofColor}
             </div>
            </div>
      </li>

      <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Extra Options</p>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">LED Light</h3>
          <div class="sum__page__main-list__info__param">${
            state.electro.has(pergolaConst.optionNameString.LEDRampLight)
              ? "Yes"
              : "No"
          }</div>
        </div>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Fan</h3>
          <div class="sum__page__main-list__info__param">${
            countVisibleObjectsByName(model, "fan", true, true) || "No"
          }</div>
        </div>

         <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Privacy Wall</h3>
          <div class="sum__page__main-list__info__param">${
            countActiveSystemsInPergola(pergolaConst.systemType.privacyWall) ||
            "No"
          }</div>
        </div>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Automated Screens</h3>
          <div class="sum__page__main-list__info__param">${
            countActiveSystemsInPergola(pergolaConst.systemType.autoShade) ||
            "No"
          }</div>
        </div>
      </li>
    </ul>
  
    <div class="sum__page__buttons">
      <button class="sum__page__buttons__button sum__page__buttons__button--back" id="back-bt">Back</button>
      <button class="sum__page__buttons__button sum__page__buttons__button--contact" id="contact-bt">Request Quote and Download PDF</button>
    </div>
  </div>
</div>
    `);

  const backButton = summaryContent.find("#back-bt");
  const contactButton = summaryContent.find("#contact-bt");
  const downloadButton = summaryContent.find("#dw-bt");

  summaryContent.find("#sum-close").on("click", () => {
    $("html, body").animate({ scrollTop: 0 }, "fast", () => {
      summaryContent.hide();
      $("body").removeClass("body-overflow-auto");
    });
  });

  backButton.on("click", () => {
    toggleLoad(true);
    $("html, body").animate({ scrollTop: 0 }, "fast", () => {
      summaryContent.hide();
      $("body").removeClass("body-overflow-auto");
    });
    toggleLoad(false);
  });

  contactButton.on("click", () => {
    loadFormData(".form-container");

    $("#sum-portal-with-comment").show();

    $("body").removeClass("body-overflow-auto");
  });

  downloadButton.on("click", async () => {
    toggleLoad(true);
    //OPEN FORM
    $("#sum-portal").show();

    $("body").removeClass("body-overflow-auto");

    // await createPDF();
    toggleLoad(false);
  });

  $(container).append(summaryContent);
}
